// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"ApartmentSearch_searchBar__2Ujfl","searchDetails":"ApartmentSearch_searchDetails__ZKTgP"};